import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class PensionPlanType extends Enum {
  static DEFINED_BENEFITS = {
    key: 'defined_benefits',
    get value() {
      return Lang.t('asset.defined-benefits');
    }
  };

  static DEFINED_CONTRIBUTIONS = {
    key: 'defined_contributions',
    get value() {
      return Lang.t('asset.defined-contributions');
    }
  };

  static GROUP_RRSP = {
    key: 'group_rrsp',
    get value() {
      return Lang.t('asset.group-rrsp');
    }
  };
}
